import {
  Button,
  CascaderSelect,
  Checkbox,
  Dialog,
  Form,
  Input,
  Message,
  Table,
} from '@alifd/next';
import { Box, Typography } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import BarcodeReader from 'react-barcode-reader';
import Swal from 'sweetalert2';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const { Item } = Form;
const AccountAccessList = () => {
  // 頁面權限設定
  const users = client.service('users');
  const residentAccountNumbers = client.service('residentAccountNumbers');
  const [usersArr, setUsersArr] = useState([]);
  const [usersArrAll, setUsersArrAll] = useState([]);
  const [auth, setAuth] = useState('');
  const [userEditIndex, setUserEditIndex] = useState(null);
  const [userActiveIndex, setUserActiveIndex] = useState(null);
  const [userEditDialog, setUserEditDialog] = useState(false);
  const [userActiveDialog, setUserActiveDialog] = useState(false);

  const [barcodeDialog, setBarcodeDialog] = useState(false);
  const [barcodeDisplay, setBarcodeDisplay] = useState('');
  const [rfidDialog, setRfidDialog] = useState(false);
  const [rfidDisplay, setRfidDisplay] = useState('');
  const [curdataIndex, setcurDataIndex] = useState('email');
  const [curorder, setcurOrder] = useState('asc');

  // 取得userGroup name data
  const [userAuthArr, setUserAuthArr] = useState([]);
  const [residentAccountNumbersArr, setResidentAccountNumbersArr] = useState(
    []
  );
  // console.log("===auth",auth)
  function householdNumberSort(a, b) {
    return a.householdNumber.localeCompare(b.householdNumber);
  }
  useEffect(() => {
    const userGroup = client.service('userGroup');
    const result = userGroup.find({}).then((result) => {
      setUserAuthArr(
        result.data.map((item) => {
          return item.name;
        })
      );
    });
    residentAccountNumbers.find({}).then((result) => {
      setResidentAccountNumbersArr(result.data.sort(householdNumberSort));
    });
  }, []);

  // 查詢
  function usersFind(para) {
    return new Promise((resolve, reject) => {
      try {
        axios
          .post(
            '/ezcon/api/postMongoAggregate',
            {
              aggregate: [
                {
                  $match: {
                    keyboardAccount: '物業keyboard帳號',
                  },
                },
              ],
              service: 'users',
            },
            {
              headers: {
                authorization: localStorage.getItem('feathers-jwt'),
              },
            }
          )
          .then((result) => {
            console.log(result);
            resolve(result && result.data ? result.data : []);
          });
      } catch (error) {
        reject(error);
      }
    });
  }

  // 更新
  async function usersUpdate(id, obj, params) {
    try {
      const result = await users.patch(id, obj, params);
      return result;
    } catch (error) {
      console.log(error.userInfo);
      console.log(typeof error.userInfo);
      throw new Error(error);
    }
  }

  const serverUsersUpdate = (dataIndex, order) => {
    const rdataIndex = dataIndex || curdataIndex;
    const rorder = order || curorder;

    usersFind().then((result) => {
      const sortedArr = result.sort((a, b) => {
        const result = (
          typeof a[rdataIndex] === 'number'
            ? a[rdataIndex].toString()
            : a[rdataIndex]
        ).localeCompare(
          typeof b[rdataIndex] === 'number'
            ? b[rdataIndex].toString()
            : b[rdataIndex]
        );
        return rorder === 'asc' ? (result > 0 ? 1 : -1) : result > 0 ? -1 : 1;
      });

      setUsersArr(sortedArr);

      setUsersArrAll(sortedArr);
    });
  };
  const onTableSort = (dataIndex, order) => {
    console.log('==dataIndex:', dataIndex, 'order:', order);
    setcurDataIndex(dataIndex);
    setcurOrder(order);
    serverUsersUpdate(dataIndex, order);
  };

  useEffect(() => {
    serverUsersUpdate();
  }, []);

  function searchRender(value) {
    // input search filter
    if (value.length > 0) {
      const sortedArr = [...usersArrAll]
        .map((e) => {
          let hasIncludes = false;
          Object.keys(e).forEach((ee) => {
            const val2 = e[ee];
            if (val2.toString().includes(value)) hasIncludes = true;
          });
          if (hasIncludes) return e;
          return false;
        })
        .filter((e) => e !== false);

      setUsersArr([...sortedArr]);
    } else {
      setUsersArr([...usersArrAll]);
    }
  }

  const handleRemoveRFId = async (rfId, record) => {
    const { rfidType, _id, auth } = record;
    const newRfIdType = rfidType.filter((e) => e !== rfId);
    try {
      await client.service('users').patch(_id, { rfidType: newRfIdType, auth });
      Message.success('刪除成功');
      serverUsersUpdate();
    } catch (err) {
      Message.error('刪除失敗');
      console.error(err);
    }
  };

  function ParseStringToArrayObject() {
    // 戶號拆解
    const data = residentAccountNumbersArr.map((i) =>
      i.householdNumber.split('-')
    );
    let Stages = [];
    function iter(e, si = 1) {
      const va = e.slice(0, si).join('-');
      if (!Stages.includes(va)) Stages.push(va);
      if (e[si]) iter(e, si + 1);
    }
    data.forEach((e) => {
      iter(e);
    });
    Stages = Stages.sort((a, b) => {
      return a.length - b.length;
    });
    const newStages = {};
    Stages.forEach((e) => {
      // (e.length==1)newStages[e] = [e];
      if (e.indexOf('-') === -1) newStages[e] = [e];
      else {
        const theDashNb = e.indexOf('-');
        // newStages[e.slice(0,1)].push(e);
        newStages[e.slice(0, theDashNb)].push(e);
      }
    });
    const FinalData = [];
    Object.keys(newStages).forEach((e) => {
      // { A:['A','A-1'],B:['B','B-1','B-1-1']...}
      const childrenObj = {};
      newStages[e].forEach((ee) => {
        let tempTarLabel = ee;
        if (ee.indexOf('-') >= 0) {
          const tempArrChild = ee.split('-');
          tempTarLabel = tempArrChild[tempArrChild.length - 1];
        }
        childrenObj[ee] = {
          label: tempTarLabel,
          value: ee,
        };
      });
      newStages[e].reverse().forEach((ee) => {
        // 底層開始 => 加入到上一層children
        // if(ee.length>=3){
        if (ee.indexOf('-') !== -1) {
          const tempArrChild = ee.split('-');
          // const ky = ee.slice(0,ee.length-2);
          const ky = tempArrChild.slice(0, tempArrChild.length - 1).join('-');
          if (!childrenObj[ky].children) {
            // 加入到上一層children
            childrenObj[ky].children = [childrenObj[ee]];
          } else {
            childrenObj[ky].children.push(childrenObj[ee]);
            childrenObj[ky].children.sort((a, b) => {
              return a.label - b.label;
            }); // label小－大
          }
        }
      });
      FinalData.push(childrenObj[Object.keys(childrenObj)[0]]); // 只取最上層(第一比obj)(資料已經都加到第一比)
    });
    // console.log(FinalData);
    return FinalData;
  }
  return (
    <>
      {/* 編輯 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={userEditDialog}
        onOk={() => {
          const item = usersArr[userEditIndex];
          item.auth = auth.join(',');

          Swal.fire({
            title: `確定修改(${item.email})帳號?`,
            text: '請確認修改資料!!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#BEBEBE',
            confirmButtonText: '確定',
            cancelButtonText: '取消',
          }).then((result) => {
            if (result.isConfirmed) {
              usersUpdate(item._id, item)
                .then((res) => {
                  console.log('==users update success:', res);

                  Swal.fire('成功!', '此帳號修改成功', 'success');
                  serverUsersUpdate();
                  // setAuth('');
                  setUserEditDialog(false);
                })
                .catch((error) => {
                  console.log('==users update fail:', error);
                  Message.error(`${error}`);
                  serverUsersUpdate();
                });
            }
          });
        }}
        onCancel={() => {
          // setAuth('');
          serverUsersUpdate();
          setUserEditDialog(false);
        }}
        onClose={() => {
          // setAuth('');
          serverUsersUpdate();
          setUserEditDialog(false);
        }}
      >
        <div>
          <h3>編輯頁面權限設定</h3>
          <Form.Item label="權限設定">
            <Checkbox.Group
              value={auth}
              dataSource={userAuthArr}
              onChange={(value) => {
                setAuth(value);
              }}
            />
          </Form.Item>
        </div>
      </Dialog>

      {/* 開通 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={userActiveDialog}
        onOk={() => {
          const obj = usersArr[userActiveIndex];

          const objLength = Object.keys(obj).length;
          if (barcodeDisplay) {
            obj.barcodeType = barcodeDisplay;
          }
          if (rfidDisplay)
            obj.rfidType = [...(obj?.rfidType || []), rfidDisplay];
          if (!barcodeDisplay && !rfidDisplay) {
            // console.log('errors: 請開通條碼及磁扣',);
            Message.error('請開通條碼及磁扣');
          } else {
            console.log(obj);
            delete obj.password;
            users
              .patch(obj._id, obj, { query: { type: 'judgeCards' } })
              .then((res) => {
                console.log('==residentrActive update success:', res);
                Message.success('開通成功');

                serverUsersUpdate();
                setBarcodeDisplay('');
                setRfidDisplay('');

                setUserActiveDialog(false);
              })
              .catch((error) => {
                console.log('==residentActive update fail:', error);
                console.log(error.userInfo);
                Message.error(`${error}`);
                serverUsersUpdate();
                setBarcodeDisplay('');
                setRfidDisplay('');
              });
          }
        }}
        onCancel={() => {
          setUserActiveDialog(false);
          setBarcodeDisplay('');
          setRfidDisplay('');
        }}
        onClose={() => {
          setUserActiveDialog(false);
          setBarcodeDisplay('');
          setRfidDisplay('');
        }}
      >
        <h1>請開通用戶條碼及磁扣</h1>

        <img
          width={300}
          height={200}
          src="/ezcon/img/Barcode.svg"
          className={styles.bcColorBlue}
          type="cover"
          style={{ border: '1px solid #ccc', margin: '10px' }}
          onClick={() => {
            setBarcodeDialog(true);
          }}
        />
        <div>值:{barcodeDisplay}</div>

        <Dialog
          hasMask
          visible={barcodeDialog}
          footer={false}
          onClose={() => {
            setBarcodeDisplay('');
            setBarcodeDialog(false);
          }}
        >
          <Form>
            <BarcodeReader
              onScan={(data) => {
                const regex = /^[\d|a-zA-Z]+$/;
                if (regex.test(data)) {
                  setBarcodeDisplay(data);
                  Message.success('掃描成功');
                  setBarcodeDialog(false);
                } else {
                  Message.error('掃描失敗，僅能數字和英文');
                  setBarcodeDialog(true);
                }
              }}
              onError={(err) => {
                console.error(err);
              }}
            />
            <Item>
              <Input
                style={{ width: '300px' }}
                placeholder="自行輸入條碼 Enter確認"
                name="barcodeDisplay"
                value={barcodeDisplay}
                onChange={(value) => {
                  setBarcodeDisplay(value);
                }}
                onPressEnter={() => {
                  const regex = /^[\d|a-zA-Z]+$/;
                  if (regex.test(barcodeDisplay)) {
                    Message.success('掃描成功');
                    setBarcodeDialog(false);
                  } else {
                    Message.error('掃描失敗，僅能數字和英文');
                    setBarcodeDialog(true);
                  }
                }}
              />
            </Item>
            <br />
            <img
              src="/ezcon/img/Barcode.svg"
              className={styles.bcColorBlue}
              alt="barcode"
              type="cover"
              width={400}
              height={300}
            />

            <h1>請掃描條碼...</h1>
          </Form>
        </Dialog>

        <img
          width={300}
          height={200}
          src="/ezcon/img/Rfid.svg"
          className={styles.bcColorBlue}
          type="cover"
          style={{ border: '1px solid #ccc', margin: '10px' }}
          onClick={() => {
            setRfidDialog(true);
          }}
        />
        <div>值:{rfidDisplay}</div>

        <Dialog
          hasMask
          visible={rfidDialog}
          footer={false}
          onClose={() => {
            setRfidDialog(false);
            setRfidDisplay('');
          }}
        >
          <Form>
            <BarcodeReader
              onScan={(data) => {
                const regex = /^[\d|a-zA-Z]+$/;
                if (regex.test(data)) {
                  setRfidDisplay(data);
                  Message.success('掃描成功');
                  setRfidDialog(false);
                } else {
                  Message.error('掃描失敗，僅能數字和英文');
                  setRfidDialog(true);
                }
              }}
              onError={(err) => {
                console.error(err);
              }}
            />
            <Item>
              <Input
                style={{ width: '300px' }}
                placeholder="自行輸入條碼 Enter確認"
                name="rfidDisplay"
                value={rfidDisplay}
                onChange={(value) => {
                  setRfidDisplay(value);
                }}
                onPressEnter={() => {
                  const regex = /^[\d|a-zA-Z]+$/;
                  if (regex.test(rfidDisplay)) {
                    Message.success('掃描成功');
                    setRfidDialog(false);
                  } else {
                    Message.error('掃描失敗，僅能數字和英文');
                    setRfidDialog(true);
                  }
                }}
              />
            </Item>

            <br />
            <img
              src="/ezcon/img/Rfid.svg"
              className={styles.bcColorBlue}
              alt="rfid"
              type="cover"
              width={400}
              height={300}
            />

            <h1>請掃描磁扣/卡片...</h1>
          </Form>
        </Dialog>
      </Dialog>

      {/* filter搜尋 */}
      {/* <div style={{ marginBottom: 10 }}>
        <CascaderSelect
          hasClear
          style={{ width: 200 }}
          placeholder="請選擇戶號"
          dataSource={ParseStringToArrayObject()}
          onChange={(value) => {
            console.log(value);
            setUsersArr(
              usersArr.filter((item) => item.householdNumbers === [value])
            );
          }}
        />
      </div> */}

      <Table dataSource={usersArr} onSort={onTableSort}>
        {/* <Table.Column
          sortable
          title="信箱(帳號)"
          dataIndex="email"
          width={150}
          lock="left"
        /> */}
        <Table.Column
          title="戶號"
          width={100}
          cell={(record, index) => {
            return (
              <>
                {usersArr[index].householdNumbers
                  ? usersArr[index].householdNumbers.map((list, index) => {
                      return <p key={index}>{list}</p>;
                    })
                  : ''}
              </>
            );
          }}
        />
        <Table.Column sortable title="用戶名" dataIndex="name" width={150} />
        {/* <Table.Column
          sortable
          title="使用者權限"
          dataIndex="auth"
          width={150}
        /> */}
        {/* <Table.Column title="開通條碼值" dataIndex="barcodeType" width={200} /> */}
        <Table.Column
          title="開通磁扣值"
          dataIndex="rfidType"
          width={200}
          cell={(val, _index, record) => {
            return (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '5px',
                }}
              >
                {Array.isArray(val)
                  ? val.map((rfId) => (
                      <Box
                        key={rfId}
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          gap: '5px',
                          alignItems: 'center',
                        }}
                      >
                        <Typography>{rfId}</Typography>
                        <Button
                          warning
                          onClick={() => handleRemoveRFId(rfId, record)}
                        >
                          刪除
                        </Button>
                      </Box>
                    ))
                  : val || ''}
              </Box>
            );
          }}
        />

        <Table.Column
          title="操作"
          width={200}
          lock="right"
          cell={(value, index, record) => {
            // console.log('==op ', value, index, record);
            // result = (
            //   '' +
            //   parseInt(
            //     parseInt(newcardnum.substr(0, 5))
            //       .toString(16)
            //       .padStart(4, '0') +
            //       parseInt(newcardnum.substr(5, 5))
            //         .toString(16)
            //         .padStart(4, '0'),
            //     16
            //   )
            // ).padStart(10, '0');
            return (
              <div className={styles.btn}>
                <Button
                  type="secondary"
                  onClick={() => {
                    setUserActiveDialog(true);
                    setUserActiveIndex(index);
                  }}
                >
                  新增條碼/磁扣值
                </Button>
              </div>
            );
          }}
        />
      </Table>
    </>
  );
};

export default AccountAccessList;
